import { CommissionInvoiceFilter } from 'src/adminPanel/entities/offsetting/commissionInvoice/CommissionInvoiceFilter';
import CommissionInvoiceRequest from 'src/adminPanel/entities/offsetting/commissionInvoice/CommissionInvoiceRequest';
import { CommissionInvoiceRequestFilter } from 'src/adminPanel/entities/offsetting/commissionInvoice/CommissionInvoiceRequestFilter';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const FETCH_COMMISSION_INVOICES_BY_FILTER = 'FETCH_COMMISSION_INVOICES_BY_FILTER';
export const REQUEST_COMMISSION_INVOICES_BY_FILTER = 'REQUEST_COMMISSION_INVOICES_BY_FILTER';
export const SUCCESS_COMMISSION_INVOICES_BY_FILTER = 'SUCCESS_COMMISSION_INVOICES_BY_FILTER';
export const FAILURE_COMMISSION_INVOICES_BY_FILTER = 'FAILURE_COMMISSION_INVOICES_BY_FILTER';

export const fetchCommissionInvoicesByFilter = (
    filter?: CommissionInvoiceRequestFilter,
    pageable?: PageableQueryParams
) => action(FETCH_COMMISSION_INVOICES_BY_FILTER, { filter, pageable });
export const requestFetchCommissionInvoicesByFilter = () => action(REQUEST_COMMISSION_INVOICES_BY_FILTER);
export const requestFetchCommissionInvoicesByFilterSuccess = (response: any) =>
    action(SUCCESS_COMMISSION_INVOICES_BY_FILTER, { response });
export const requestFetchCommissionInvoicesByFilterFailure = (error: any) =>
    action(FAILURE_COMMISSION_INVOICES_BY_FILTER, { error });

export const FETCH_COMMISSION_INVOICES_BY_FILTER_ID = 'FETCH_COMMISSION_INVOICES_BY_FILTER_ID';
export const REQUEST_COMMISSION_INVOICES_BY_FILTER_ID = 'REQUEST_COMMISSION_INVOICES_BY_FILTER_ID';
export const SUCCESS_COMMISSION_INVOICES_BY_FILTER_ID = 'SUCCESS_COMMISSION_INVOICES_BY_FILTER_ID';
export const FAILURE_COMMISSION_INVOICES_BY_FILTER_ID = 'FAILURE_COMMISSION_INVOICES_BY_FILTER_ID';

export const fetchCommissionInvoicesByFilterId = (filterId: string, pageable?: PageableQueryParams) =>
    action(FETCH_COMMISSION_INVOICES_BY_FILTER_ID, { filterId, pageable });
export const requestFetchCommissionInvoicesByFilterId = () => action(REQUEST_COMMISSION_INVOICES_BY_FILTER_ID);
export const requestFetchCommissionInvoicesByFilterIdSuccess = (response: any) =>
    action(SUCCESS_COMMISSION_INVOICES_BY_FILTER_ID, { response });
export const requestFetchCommissionInvoicesByFilterIdFailure = (error: any) =>
    action(FAILURE_COMMISSION_INVOICES_BY_FILTER_ID, { error });

export const FETCH_COMMISSION_INVOICE_FILTERS = 'FETCH_COMMISSION_INVOICE_FILTERS';
export const REQUEST_COMMISSION_INVOICE_FILTERS = 'REQUEST_COMMISSION_INVOICE_FILTERS';
export const SUCCESS_COMMISSION_INVOICE_FILTERS = 'SUCCESS_COMMISSION_INVOICE_FILTERS';
export const FAILURE_COMMISSION_INVOICE_FILTERS = 'FAILURE_COMMISSION_INVOICE_FILTERS';

export const fetchCommissionInvoiceFilters = () => action(FETCH_COMMISSION_INVOICE_FILTERS);
export const requestFetchCommissionInvoiceFilters = () => action(REQUEST_COMMISSION_INVOICE_FILTERS);
export const requestFetchCommissionInvoiceFiltersSuccess = (response: any) =>
    action(SUCCESS_COMMISSION_INVOICE_FILTERS, { response });
export const requestFetchCommissionInvoiceFiltersFailure = (error: any) =>
    action(FAILURE_COMMISSION_INVOICE_FILTERS, { error });

export const CREATE_NEW_COMMISSION_INVOICE = 'CREATE_NEW_COMMISSION_INVOICE';
export const REQUEST_CREATE_NEW_COMMISSION_INVOICE = 'REQUEST_CREATE_NEW_COMMISSION_INVOICE';
export const SUCCESS_CREATE_NEW_COMMISSION_INVOICE = 'SUCCESS_CREATE_NEW_COMMISSION_INVOICE';
export const FAILURE_CREATE_NEW_COMMISSION_INVOICE = 'FAILURE_CREATE_NEW_COMMISSION_INVOICE';

export const createNewCommissionInvoice = (newCommissionInvoice: CommissionInvoiceRequest) =>
    action(CREATE_NEW_COMMISSION_INVOICE, { newCommissionInvoice });
export const requestCreateNewCommissionInvoice = () => action(REQUEST_CREATE_NEW_COMMISSION_INVOICE);
export const requestCreateNewCommissionInvoiceSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_COMMISSION_INVOICE, { response });
export const requestCreateNewCommissionInvoiceFailure = (error: any) =>
    action(FAILURE_CREATE_NEW_COMMISSION_INVOICE, { error });

export const FETCH_COMMISSION_INVOICE_PDF = 'FETCH_COMMISSION_INVOICE_PDF';
export const REQUEST_COMMISSION_INVOICE_PDF = 'REQUEST_COMMISSION_INVOICE_PDF';
export const SUCCESS_COMMISSION_INVOICE_PDF = 'SUCCESS_COMMISSION_INVOICE_PDF';
export const FAILURE_COMMISSION_INVOICE_PDF = 'FAILURE_COMMISSION_INVOICE_PDF';

export const fetchCommissionInvoicePdf = (commissionInvoiceId: string) =>
    action(FETCH_COMMISSION_INVOICE_PDF, { commissionInvoiceId });
export const requestFetchCommissionInvoicePdf = () => action(REQUEST_COMMISSION_INVOICE_PDF);
export const requestFetchCommissionInvoicePdfSuccess = (response: any) =>
    action(SUCCESS_COMMISSION_INVOICE_PDF, { response });
export const requestFetchCommissionInvoicePdfFailure = (error: any) =>
    action(FAILURE_COMMISSION_INVOICE_PDF, { error });

export const FETCH_COMMISSION_INVOICE_DETAILS_PDF = 'FETCH_COMMISSION_INVOICE_DETAILS_PDF';
export const REQUEST_COMMISSION_INVOICE_DETAILS_PDF = 'REQUEST_COMMISSION_INVOICE_DETAILS_PDF';
export const SUCCESS_COMMISSION_INVOICE_DETAILS_PDF = 'SUCCESS_COMMISSION_INVOICE_DETAILS_PDF';
export const FAILURE_COMMISSION_INVOICE_DETAILS_PDF = 'FAILURE_COMMISSION_INVOICE_DETAILS_PDF';

export const fetchCommissionInvoiceDetailsPdf = (commissionInvoiceId: string) =>
    action(FETCH_COMMISSION_INVOICE_DETAILS_PDF, { commissionInvoiceId });
export const requestFetchCommissionInvoiceDetailsPdf = () => action(REQUEST_COMMISSION_INVOICE_DETAILS_PDF);
export const requestFetchCommissionInvoiceDetailsPdfSuccess = (response: any) =>
    action(SUCCESS_COMMISSION_INVOICE_DETAILS_PDF, { response });
export const requestFetchCommissionInvoiceDetailsPdfFailure = (error: any) =>
    action(FAILURE_COMMISSION_INVOICE_DETAILS_PDF, { error });

// CommissionInvoiceFilter
export const CREATE_NEW_COMMISSION_INVOICE_FILTER = 'CREATE_NEW_COMMISSION_INVOICE_FILTER';
export const REQUEST_CREATE_NEW_COMMISSION_INVOICE_FILTER = 'REQUEST_CREATE_NEW_COMMISSION_INVOICE_FILTER';
export const SUCCESS_CREATE_NEW_COMMISSION_INVOICE_FILTER = 'SUCCESS_CREATE_NEW_COMMISSION_INVOICE_FILTER';
export const FAILURE_CREATE_NEW_COMMISSION_INVOICE_FILTER = 'FAILURE_CREATE_NEW_COMMISSION_INVOICE_FILTER';

export const createNewCommissionInvoiceFilter = (newFilter: CommissionInvoiceFilter) =>
    action(CREATE_NEW_COMMISSION_INVOICE_FILTER, { newFilter });
export const requestCreateNewCommissionInvoiceFilter = () => action(REQUEST_CREATE_NEW_COMMISSION_INVOICE_FILTER);
export const requestCreateNewCommissionInvoiceFilterSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_COMMISSION_INVOICE_FILTER, { response });
export const requestCreateNewCommissionInvoiceFilterFailure = (error: any) =>
    action(FAILURE_CREATE_NEW_COMMISSION_INVOICE_FILTER, { error });

export const UPDATE_COMMISSION_INVOICE_FILTER = 'UPDATE_COMMISSION_INVOICE_FILTER';
export const REQUEST_UPDATE_COMMISSION_INVOICE_FILTER = 'REQUEST_UPDATE_COMMISSION_INVOICE_FILTER';
export const SUCCESS_UPDATE_COMMISSION_INVOICE_FILTER = 'SUCCESS_UPDATE_COMMISSION_INVOICE_FILTER';
export const FAILURE_UPDATE_COMMISSION_INVOICE_FILTER = 'FAILURE_UPDATE_COMMISSION_INVOICE_FILTER';

export const updateCommissionInvoiceFilter = (newFilter: CommissionInvoiceFilter) =>
    action(UPDATE_COMMISSION_INVOICE_FILTER, { newFilter });
export const requestUpdateCommissionInvoiceFilter = () => action(REQUEST_UPDATE_COMMISSION_INVOICE_FILTER);
export const requestUpdateCommissionInvoiceFilterSuccess = (response: any) =>
    action(SUCCESS_UPDATE_COMMISSION_INVOICE_FILTER, { response });
export const requestUpdateCommissionInvoiceFilterFailure = (error: any) =>
    action(FAILURE_UPDATE_COMMISSION_INVOICE_FILTER, { error });

export const DELETE_COMMISSION_INVOICE_FILTER = 'DELETE_COMMISSION_INVOICE_FILTER';
export const REQUEST_DELETE_COMMISSION_INVOICE_FILTER = 'REQUEST_DELETE_COMMISSION_INVOICE_FILTER';
export const SUCCESS_DELETE_COMMISSION_INVOICE_FILTER = 'SUCCESS_DELETE_COMMISSION_INVOICE_FILTER';
export const FAILURE_DELETE_COMMISSION_INVOICE_FILTER = 'FAILURE_DELETE_COMMISSION_INVOICE_FILTER';

export const deleteCommissionInvoiceFilter = (filterId: string) =>
    action(DELETE_COMMISSION_INVOICE_FILTER, { filterId });
export const requestDeleteCommissionInvoiceFilter = () => action(REQUEST_DELETE_COMMISSION_INVOICE_FILTER);
export const requestDeleteCommissionInvoiceFilterSuccess = (response: any) =>
    action(SUCCESS_DELETE_COMMISSION_INVOICE_FILTER, { response });
export const requestDeleteCommissionInvoiceFilterFailure = (error: any) =>
    action(FAILURE_DELETE_COMMISSION_INVOICE_FILTER, { error });

// CommissionInvoiceDetails
export const FETCH_COMMISSION_INVOICE_DETAILS = 'FETCH_COMMISSION_INVOICE_DETAILS';
export const REQUEST_FETCH_COMMISSION_INVOICE_DETAILS = 'REQUEST_FETCH_COMMISSION_INVOICE_DETAILS';
export const SUCCESS_FETCH_COMMISSION_INVOICE_DETAILS = 'SUCCESS_FETCH_COMMISSION_INVOICE_DETAILS';
export const FAILURE_FETCH_COMMISSION_INVOICE_DETAILS = 'FAILURE_FETCH_COMMISSION_INVOICE_DETAILS';

export const fetchCommissionInvoiceDetails = (commissionInvoiceId: string) =>
    action(FETCH_COMMISSION_INVOICE_DETAILS, { commissionInvoiceId });
export const requestFetchCommissionInvoiceDetails = () => action(REQUEST_FETCH_COMMISSION_INVOICE_DETAILS);
export const requestFetchCommissionInvoiceDetailsSuccess = (response: any) =>
    action(SUCCESS_FETCH_COMMISSION_INVOICE_DETAILS, { response });
export const requestFetchCommissionInvoiceDetailsFailure = (error: any) =>
    action(FAILURE_FETCH_COMMISSION_INVOICE_DETAILS, { error });

export const CLEAR_COMMISSION_INVOICE_DETAILS = 'CLEAR_COMMISSION_INVOICE_DETAILS';
export const REQUEST_CLEAR_COMMISSION_INVOICE_DETAILS = 'REQUEST_CLEAR_COMMISSION_INVOICE_DETAILS';

export const clearCommissionInvoiceDetails = () => action(CLEAR_COMMISSION_INVOICE_DETAILS);
export const requestClearCommissionInvoiceDetails = () => action(REQUEST_CLEAR_COMMISSION_INVOICE_DETAILS);
